export default "__VITE_ASSET__DTuORu6Y__"